<template>
  <v-content class="overflow">
    <app-home></app-home>
    <app-services></app-services>
    <app-about></app-about>
    <app-contact></app-contact>
  </v-content>
</template>

<script>
  import Home from './sections/Home.vue';
  import Services from './sections/Services.vue';
  import About from './sections/About.vue';
  import Contact from './sections/Contact.vue';
  export default {
    props: {
      source: String
    },
    components: {
      'app-home': Home,
      'app-services': Services,
      'app-about': About,
      'app-contact': Contact,
    }
  }
</script>

<style scoped>

.title-home {
  font-weight: 300;
  font-size: 6.5em;
}

.title-contact {
  margin-top: -120px;
}

.overflow {
  overflow: hidden;
}

</style>






// WEBPACK FOOTER //
// src/components/IndexComponent.vue